import { logger } from 'services';
const listeners = new Set();
/**
 * "A task was just created by this user, in this tab."
 *
 * Boards cannot infer this from `taskCollection` alone. Every create helper
 * lands its result with `taskCollection.push`, and `push` deliberately does
 * NOT notify `subscribeToMutations` — that channel is for optimistic
 * insert/update/delete, and `push` is the hydration / WS-refetch path (see
 * `Collection.subscribeToMutations` in `packages/state-db`). Reaching for
 * `subscribeToChanges` instead is not an option either: it fires for bulk list
 * hydration too, which is what produced the per-task
 * `getSwimlaneDataForTaskId` request storm the kanban board deliberately moved
 * off.
 *
 * Nor can a board use `Collection.insert`: the tasks collection configures an
 * `onInsert` handler (`task-collection.ts`) that POSTs, so inserting a task
 * the server has already created would create it twice.
 *
 * Hence this narrow channel: exactly one event per user-initiated create,
 * never fired for hydration. Project and sprint kanban boards need it because
 * they suppress their own WS echo (`skipSelfEcho`) on the assumption that they
 * hold an optimistic local representation of the change — true for edits,
 * false for creates.
 */ export const subscribeToTaskCreated = (listener)=>{
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
};
/**
 * Announce a freshly created task. A throwing subscriber must never break the
 * create flow that emitted the event — the task is already persisted by this
 * point, so the only thing an exception here can do is lose UI updates for the
 * OTHER subscribers.
 */ export const notifyTaskCreated = (task)=>{
    listeners.forEach((listener)=>{
        try {
            listener(task);
        } catch (error) {
            logger.error('taskCreated subscriber threw', {
                error,
                taskId: task === null || task === void 0 ? void 0 : task.taskId
            });
        }
    });
};
